import { userRoles } from '@constants/common';
import { lazy } from 'solid-js';

const HelpdeskOperations = lazy(() => import('./HelpdeskOperations'));

const protectedRoute = (
  path: string,
  page:
    | 'access'
    | 'resync'
    | 'office'
    | 'efs'
    | 'highway'
    | 'revenue'
    | 'secureRateCon',
) => ({
  path,
  component: () => <HelpdeskOperations page={page} />,
  protected: true,
  roles: [userRoles.ADMIN, userRoles.SUPER_ADMIN],
});

export const HelpdeskAccessRoute = protectedRoute(
  '/helpdesk/order-access',
  'access',
);
export const HelpdeskResyncRoute = protectedRoute('/helpdesk/resync', 'resync');
export const HelpdeskOfficeMoveRoute = protectedRoute(
  '/helpdesk/office-reassignment',
  'office',
);
export const HelpdeskEfsValidationRoute = protectedRoute(
  '/helpdesk/efs-validation',
  'efs',
);
export const HelpdeskHighwaySyncRoute = protectedRoute(
  '/helpdesk/highway-carrier-sync',
  'highway',
);
export const HelpdeskRevenueTriageRoute = protectedRoute(
  '/helpdesk/revenue-triage',
  'revenue',
);
export const HelpdeskSecureRateConRoute = protectedRoute(
  '/helpdesk/secure-rate-con',
  'secureRateCon',
);
